import { useState, useEffect } from 'react';

const useMount = () => {
  const [mount, setMount] = useState<boolean | null>(null);

  useEffect(() => {
    setMount(true);
    return () => setMount(null);
  }, []);

  return mount;
};

export default useMount;
